import {createGenericSlice, GenericActions, GenericState} from "../GenericSlice";
import {PayloadAction} from "@reduxjs/toolkit";
import { PastCampaignsType } from "../../app/Subscriptions/types/CampaignsTypes";
import { format } from 'date-fns';


type State = {
    data: PastCampaignsType[];
};

const initialState: State = {
    data: []
};

export const PastCampaignSlice = createGenericSlice({
    name: "PastCampaigns",
    initialState: initialState as GenericState<PastCampaignsType[]>,
    reducers: {
        success: {
            reducer: (state: { data: PastCampaignsType[]; status: string; }, action: PayloadAction<PastCampaignsType[]>) => {
                state.data = action.payload;
                state.status = 'finished';
            },
            prepare: (PastCampaigns: any) => {

                const PastCampaignsArray: PastCampaignsType[] = PastCampaigns.map((PastCampaign: any) => {
                    
                   
                    
                    return {
                        delivered: PastCampaign.delivered ? PastCampaign.delivered : 0,
                        message: PastCampaign.message,
                        photo_url: PastCampaign.photo_url,
                        processed: PastCampaign.processed ? PastCampaign.processed : 0,
                        providerReference: PastCampaign.providerReference,
                        sent: PastCampaign.sent ? PastCampaign.sent : 0,
                        interested: PastCampaign.interested ? PastCampaign.interested : 0,
                        failed: PastCampaign.failed ? PastCampaign.failed : 0,
                        template: PastCampaign.template,
                        timestamp: PastCampaign.timestamp ? format(PastCampaign.timestamp.toDate(), 'MMM dd yyyy') : '',
                        id: PastCampaign.id
                    };
                });

                return {payload: PastCampaignsArray};
            }
        }
    }
});

export const actions = PastCampaignSlice.actions as GenericActions<PastCampaignsType[]>;

export default PastCampaignSlice.reducer;
